import {Radio, RadioGroup} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {FormEvent, useContext, useMemo} from "react";
import {ColorizedIndicatorContext, ColorizedIndicatorDispatchContext} from "./ColorizedIndicatorStateProvider";
import {ComparisonTypes} from "./types/indicatorLogicType";
import {JobTypes} from "./types/jobTypeSelectorValues";
import {extractSimplePref, usePreferenceContext} from "../../../../providers/PreferenceProvider";
import {TenantPreferences} from "../../../../constants/constants";

const StyledRadioGroup = styled(RadioGroup)`
  .bp5-control input:checked ~ .bp5-control-indicator {
    background-color: #14305a;
  }
`;

const ComparisonTypeSelector = () => {
  const indicatorColorState = useContext(ColorizedIndicatorContext);
  const indicatorDispatch = useContext(ColorizedIndicatorDispatchContext);
  const {tenantPreferences} = usePreferenceContext();

  const isUseETAService = useMemo(() => {
    return extractSimplePref(tenantPreferences, TenantPreferences.useEtaService, true).value;
  }, [tenantPreferences]);
  const selectedValue = indicatorColorState.selectedLogic;

  const handleOnComparisonTypeChange = (event: FormEvent<HTMLInputElement>): void => {
    indicatorDispatch({type: "SET_COMPARISON_TYPE", payload: event.currentTarget.value as ComparisonTypes});
    indicatorDispatch({type: "SET_ENGINE_RULES"});
  };

  return (
    <StyledRadioGroup onChange={handleOnComparisonTypeChange} selectedValue={selectedValue?.comparison}>
      <Radio
        label={
          selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops
            ? "Scheduled Time to Current Time"
            : "Scheduled Time of first stop"
        }
        value={
          selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops
            ? ComparisonTypes.ScheduledTime
            : ComparisonTypes.FirstStop
        }
      />
      <Radio
        label={
          selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops
            ? "Late Time to Current Time"
            : "Scheduled Time of last stop"
        }
        value={
          selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops
            ? ComparisonTypes.LateTime
            : ComparisonTypes.LastStop
        }
      />
      {isUseETAService && selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops && (
        <Radio label={"ETA Time to Scheduled Time"} value={ComparisonTypes.ETAToScheduledTime} />
      )}
      {isUseETAService && selectedValue?.type?.jobTypeValue === JobTypes.AssignedStops && (
        <Radio label={"ETA Time to Late Time"} value={ComparisonTypes.ETAToLateTime} />
      )}
      <Radio label="Continuous" value={ComparisonTypes.Continuous}></Radio>
    </StyledRadioGroup>
  );
};

export default ComparisonTypeSelector;
